// extracted by mini-css-extract-plugin
export var label = "_f8-2";
export var slideContainer = "_f8-0";
export var slider = "_f8-1";